import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";

import { faMailBulk } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
	faTwitter,
	faGithub,
	faStackOverflow,
	faInstagram,
} from "@fortawesome/free-brands-svg-icons";

import Logo from "../components/common/logo";
import Footer from "../components/common/footer";
import NavBar from "../components/common/navBar";
import Article from "../components/homepage/article";
import Works from "../components/homepage/works";
import AllProjects from "../components/projects/allProjects";

import INFO from "../data/user";
import SEO from "../data/seo";
import myArticles from "../data/articles";

import "./styles/homepage.css";

const Homepage = () => {
	const [stayLogo, setStayLogo] = useState(false);
	const [logoSize, setLogoSize] = useState(80);
	const [oldLogoSize, setOldLogoSize] = useState(80);

	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	useEffect(() => {
		const handleScroll = () => {
			let scroll = Math.round(window.pageYOffset, 2);

			let newLogoSize = 80 - (scroll * 4) / 10;

			if (newLogoSize < oldLogoSize) {
				if (newLogoSize > 40) {
					setLogoSize(newLogoSize);
					setOldLogoSize(newLogoSize);
					setStayLogo(false);
				} else {
					setStayLogo(true);
				}
			} else {
				setLogoSize(newLogoSize);
				setStayLogo(false);
			}
		};

		window.addEventListener("scroll", handleScroll);
		return () => window.removeEventListener("scroll", handleScroll);
	}, [logoSize, oldLogoSize]);

	const currentSEO = SEO.find((item) => item.page === "home");

	const logoStyle = {
		display: "flex",
		position: stayLogo ? "fixed" : "relative",
		top: stayLogo ? "3vh" : "auto",
		zIndex: 999,
		border: stayLogo ? "1px solid white" : "none",
		borderRadius: stayLogo ? "50%" : "none",
		boxShadow: stayLogo ? "0px 4px 10px rgba(0, 0, 0, 0.25)" : "none",
	};

	return (
		<React.Fragment>
			<Helmet>
				<title>{INFO.main.title}</title>
				<meta name="description" content={currentSEO.description} />
				<meta
					name="keywords"
					content={currentSEO.keywords.join(", ")}
				/>
			</Helmet>

			<div className="page-content">
				<NavBar active="home" />
				<div className="content-wrapper">
					<div className="homepage-logo-container">
						<div style={logoStyle}>
							<Logo width={logoSize} link={false} />
						</div>
					</div>

					<div className="homepage-container">
						<div className="homepage-first-area">
							<div className="homepage-first-area-left-side">
								<div className="title homepage-title">
									{INFO.homepage.title}
								</div>

								<div className="subtitle homepage-subtitle">
									{INFO.homepage.description}
								</div>
							</div>

							<div className="homepage-first-area-right-side">
								<div className="homepage-image-container">
									<div className="homepage-image-wrapper">
										<img
											src="sardar.jpeg"
											alt="about"
											className="homepage-image"
										/>
									</div>
								</div>
							</div>
						</div>

						<div className="homepage-container" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
							<div className="homepage-socials">
								<a href={INFO.socials.twitter} target="_blank" rel="noreferrer">
									<FontAwesomeIcon icon={faTwitter} className="homepage-social-icon" />
								</a>
								<a href={INFO.socials.github} target="_blank" rel="noreferrer">
									<FontAwesomeIcon icon={faGithub} className="homepage-social-icon" />
								</a>
								<a href={INFO.socials.stackoverflow} target="_blank" rel="noreferrer">
									<FontAwesomeIcon icon={faStackOverflow} className="homepage-social-icon" />
								</a>
								<a href={INFO.socials.instagram} target="_blank" rel="noreferrer">
									<FontAwesomeIcon icon={faInstagram} className="homepage-social-icon" />
								</a>
								<a href={`mailto:${INFO.main.email}`} target="_blank" rel="noreferrer">
									<FontAwesomeIcon icon={faMailBulk} className="homepage-social-icon" />
								</a>
							</div>

							<div className="homepage-svg" style={{ marginLeft: '20px' }}>
								<svg xmlns="http://www.w3.org/2000/svg" height="200" width="200">
									<g style={{ order: -1 }}>
										<polygon transform="rotate(45 100 100)" strokeWidth="1" stroke="#d3a410" fill="none" points="70,70 148,50 130,130 50,150" id="bounce"></polygon>
										<polygon transform="rotate(45 100 100)" strokeWidth="1" stroke="#d3a410" fill="none" points="70,70 148,50 130,130 50,150" id="bounce2"></polygon>
										<polygon transform="rotate(45 100 100)" strokeWidth="2" fill="#414750" points="70,70 150,50 130,130 50,150"></polygon>
										<polygon strokeWidth="2" fill="url(#gradiente)" points="100,70 150,100 100,130 50,100"></polygon>
										<defs>
											<linearGradient y2="100%" x2="10%" y1="0%" x1="0%" id="gradiente">
												<stop style={{ stopColor: '#1e2026', stopOpacity: 1 }} offset="20%"></stop>
												<stop style={{ stopColor: '#414750', stopOpacity: 1 }} offset="60%"></stop>
											</linearGradient>
										</defs>
										<polygon transform="translate(20, 31)" strokeWidth="2" fill="#b7870f" points="80,50 80,75 80,99 40,75"></polygon>
										<polygon transform="translate(20, 31)" strokeWidth="2" fill="url(#gradiente2)" points="40,-40 80,-40 80,99 40,75"></polygon>
										<defs>
											<linearGradient y2="100%" x2="0%" y1="-17%" x1="10%" id="gradiente2">
												<stop style={{ stopColor: '#d3a51000', stopOpacity: 1 }} offset="20%"></stop>
												<stop style={{ stopColor: '#d3a51054', stopOpacity: 1 }} offset="100%" id="animatedStop"></stop>
											</linearGradient>
										</defs>
										<polygon transform="rotate(180 100 100) translate(20, 20)" strokeWidth="2" fill="#d3a410" points="80,50 80,75 80,99 40,75"></polygon>
										<polygon transform="rotate(0 100 100) translate(60, 20)" strokeWidth="2" fill="url(#gradiente3)" points="40,-40 80,-40 80,85 40,110.2"></polygon>
										<defs>
											<linearGradient y2="100%" x2="10%" y1="0%" x1="0%" id="gradiente3">
												<stop style={{ stopColor: '#d3a51000', stopOpacity: 1 }} offset="20%"></stop>
												<stop style={{ stopColor: '#d3a51054', stopOpacity: 1 }} offset="100%" id="animatedStop"></stop>
											</linearGradient>
										</defs>
										<polygon transform="rotate(45 100 100) translate(80, 95)" strokeWidth="2" fill="#ffe4a1" points="5,0 5,5 0,5 0,0" id="particles"></polygon>
										<polygon transform="rotate(45 100 100) translate(80, 55)" strokeWidth="2" fill="#ccb069" points="6,0 6,6 0,6 0,0" id="particles"></polygon>
										<polygon transform="rotate(45 100 100) translate(70, 80)" strokeWidth="2" fill="#fff" points="2,0 2,2 0,2 0,0" id="particles"></polygon>
										<polygon strokeWidth="2" fill="#292d34" points="29.5,99.8 100,142 100,172 29.5,130"></polygon>
										<polygon transform="translate(50, 92)" strokeWidth="2" fill="#1f2127" points="50,50 120.5,8 120.5,35 50,80"></polygon>
									</g>
								</svg>
							</div>
						</div>


						<div className="homepage-projects">
							<AllProjects />
						</div>

						<div className="homepage-after-title">
							<div className="homepage-articles">
								{myArticles.slice(0, 1).map((article, index) => (
									<div
										className="homepage-article"
										key={(index + 1).toString()}
									>
										<Article
											key={(index + 1).toString()}
											date={article().date}
											title={article().title}
											description={article().description}
											link={"/article/" + (index + 1)}
										/>
									</div>
								))}
							</div>

							<div className="homepage-works">
								<Works />
							</div>
						</div>

						<div className="page-footer">
							<Footer />
						</div>
					</div>
				</div>
			</div>
		</React.Fragment>
	);
};

export default Homepage;
